import React, { useState } from "react";
import FsLightbox from "fslightbox-react";
import { FiPlay } from "react-icons/fi";

const videoLinks = [
    "https://youtu.be/15A6cqAXvQg",
    "https://youtu.be/6Bl8GgiNpjo",
    "https://youtu.be/y-NygYKLg14",
    "https://youtu.be/H7218RbYhxs",
    "https://youtu.be/U_9Ysjz4-ls",
    "https://youtu.be/5i7bfcbKJ7E",
    "https://youtu.be/Nb-0YFcJ4OA",
];

function SpeakingVideo() {
  const [toggler, setToggler] = useState(false);
  // State changed to activeSource to hold the custom iframe element
  const [activeSource, setActiveSource] = useState(null);

  const getYouTubeThumbnail = (url) => {
    let videoId = "";
    if (url.includes("youtu.be")) {
      videoId = url.split("youtu.be/")[1].split("?")[0];
    } else if (url.includes("youtube.com")) {
      videoId = url.split("v=")[1]?.split("&")[0];
    }
    return `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
  };

  const openLightbox = (index) => {
    const videoUrl = videoLinks[index];
    
    // 1. Extract the Video ID
    let videoId = "";
    if (videoUrl.includes("youtu.be")) {
      videoId = videoUrl.split("youtu.be/")[1].split("?")[0];
    } else if (videoUrl.includes("youtube.com")) {
      videoId = videoUrl.split("v=")[1]?.split("&")[0];
    }
    
    // 2. Create the YouTube Embed URL
    const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`; 
    
    // 3. Create the custom iframe wrapped in a responsive container
    const customIframe = (
      <div 
        style={{
          position: 'relative',
          // Set to 90% of viewport width for "almost fullscreen"
          width: '90vw', 
          // Sets the height to maintain 16:9 aspect ratio relative to the 90vw width
          paddingTop: '50.625vw', // (9 / 16) * 90 = 50.625
          margin: '0 auto',
          display: 'block', 
          marginTop: '30px',
        }}
      >
        <iframe
          // 👇 REFERRERPOLICY added here
          referrerPolicy="strict-origin-when-cross-origin" 
          src={embedUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          // The iframe must be absolute to fill the parent div's responsive box
          style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '90%',
          }}
        />
      </div>
    );
    
    // 4. Set the custom iframe as the active source and toggle the lightbox
    setActiveSource(customIframe); 
    setToggler(!toggler);
  };

  return (
    <div className="row row--15">
      {videoLinks.map((link, index) => (
        <div className="col-lg-4 col-md-6 col-12 mt--30" key={index}>
          <div className="video-popup icon-center">
            <div className="thumbnail">
              <img
                className="radius-small"
                src={getYouTubeThumbnail(link)}
                alt={`Video ${index + 1}`}
              />
            </div>
            <div className="video-icon">
              <button
                className="btn-default rounded-player"
                onClick={() => openLightbox(index)}
              >
                <span>
                  <FiPlay />
                </span>
              </button>
            </div>
          </div>
        </div>
      ))}

      {/* 5. FsLightbox uses activeSource */}
      {activeSource && (
        <FsLightbox toggler={toggler} sources={[activeSource]} />
      )}
    </div>
  );
}

export default SpeakingVideo;